import axios from 'axios';
import cuid from 'cuid';
import _ from 'lodash';
import { useEffect } from 'react';

import { API_BASE_URL, GET_CONFIGURATION_OKTA } from '../../constants/api';
import { getAccessToken } from '../SecurityProvider/oktaAuthInstance';

export function makeAuthInterceptor() {
  return (config) => {
    const isApiRequest = !_.isNil(config.url) && (config.url === API_BASE_URL || config.url.startsWith(`${API_BASE_URL}/`));
    if (isApiRequest && config.url.indexOf(`${GET_CONFIGURATION_OKTA}`) < 0) {
      const access_token = getAccessToken();
      let agentsOnlySessionUUID = localStorage.getItem('afe-session-id');
      if (agentsOnlySessionUUID === undefined || agentsOnlySessionUUID === null) {
        const sessionCUID = cuid();
        localStorage.setItem('afe-session-id', sessionCUID);
        agentsOnlySessionUUID = localStorage.getItem('afe-session-id');
      }
      if (access_token !== undefined && access_token !== null) {
        config.headers.access_token = 'Bearer ' + access_token;
      }
      config.headers['afe-session-id'] = agentsOnlySessionUUID;
    }
    config.headers['afe-trace-id'] = cuid();
    localStorage.removeItem('afe-trace-id');
    localStorage.setItem('afe-trace-id', config.headers['afe-trace-id']);
    return config;
  };
}

/* Interceptor Component for axios to add auth token and sessionUUID in header */
function AppAxiosInterceptor() {
  useEffect(() => {
    const authInterceptor = axios.interceptors.request.use(makeAuthInterceptor(), (error) => {
      return Promise.reject(error);
    });
    const errorInterceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    return () => {
      axios.interceptors.request.eject(authInterceptor);
      axios.interceptors.response.eject(errorInterceptor);
    };
  }, []);

  return null;
}

export default AppAxiosInterceptor;
